// Main widgets export for external usage
import ForumWidget from './components/interactiveWidgets/ForumWidget.vue'
import VotingWidget from './components/interactiveWidgets/VotingWidget.vue'
import QandAWidget from './components/interactiveWidgets/QandAWidget.vue'
import WordCloudWidget from './components/interactiveWidgets/WordCloudWidget.vue'

export { ForumWidget, VotingWidget, QandAWidget, WordCloudWidget }

// Composables for custom implementations
export { useApi } from './composables/useApi.js'
export { useWebSocket } from './composables/useWebSocket.js'

// Configuration utilities - Import AND export
import { getAudienceConfig, validateConfig } from './utils/config.js'
export { getAudienceConfig, validateConfig }

// Install function for Vue app
export const install = (app, options = {}) => {
    try {
        const defaultConfig = getAudienceConfig()
        const finalConfig = { ...defaultConfig, ...options.config }

        // ALWAYS set global config - this is important for widget consistency!
        console.log("Installing audience widgets with config:", finalConfig)
        window.AUDIENCE_CONFIG = finalConfig;
        console.log("AUDIENCE_CONFIG set:", window.AUDIENCE_CONFIG)
        
        // Validate the config
        const validation = validateConfig(finalConfig)
        if (!validation.valid) {
            console.warn('⚠️ Audience widgets config validation warnings:', validation)
        }
        
        // Register components globally
        app.component('ForumWidget', ForumWidget)
        app.component('VotingWidget', VotingWidget)
        app.component('QandAWidget', QandAWidget)
        app.component('WordCloudWidget', WordCloudWidget)
        
        console.log("✅ All audience widgets registered successfully")
    } catch (error) {
        console.error('Failed to install audience widgets:', error)
    }
}

// Default export for plugin installation
export default {
    install
}
